'use strict';


export default function() {
	return {
		transclude: true,
		template: `
		<div class="panel panel-default">
			<div expansion-container class="panel-body action-box">
				<div ng-transclude></div>
			</div>
		</div>`,
		link: postLink,
	}

	function postLink(scope, element, attrs) {
		if(!element[0].querySelector('.action-box-option-group')) {
			element.addClass('no-options');
		}
	}
}
